import React, { useState } from 'react'
import { Button, Form, Spinner } from 'react-bootstrap'
import { RiCloseLine } from 'react-icons/ri'
import { useUploadDementiaFileMutation } from '../../redux/api/brainApi'
import CustomDropzone from '../CustomDropzone'

const DementiaForm = ({ setResult, setError, setFileNum }) => {
  const [selectedFile, setSelectedFile] = useState(null)
  const [isUploading, setIsUploading] = useState(false)
  const [uploadDementiaFile] = useUploadDementiaFileMutation()

  const extractSubjectNumber = (filename) => {
    const match = filename.match(/sub-(\d+)/)
    return match ? parseInt(match[1]) : 1
  }

  const handleFileSubmit = (file) => {
    setSelectedFile(file)
  }
  const handleRemoveFile = () => {
    setSelectedFile(null)
  }
  const handleUpload = async (event) => {
    event.preventDefault()
    if (!selectedFile) return
    setIsUploading(true)
    setError('')
    setResult(null)

    const extractedNum = extractSubjectNumber(selectedFile.name)
    setFileNum(extractedNum)

    try {
      const data = await uploadDementiaFile({ file: selectedFile, file_num: extractedNum }).unwrap()
      setSelectedFile(null)
      setResult(data.probability === '1.0')
    } catch (error) {
      setError(error.data?.error || 'Upload failed. Please try again.')
    } finally {
      setIsUploading(false)
    }
  }
  return (
    <Form onSubmit={handleUpload}>
      <h4 className='mb-3'>Upload Scan</h4>
      <CustomDropzone
        isMultiple={false}
        onSubmit={handleFileSubmit}
        loading={isUploading}
        acceptedFileTypes={{ '.set': [] }}
      />

      {selectedFile && (
        <div className='mt-3 p-2 border rounded'>
          <div className='d-flex justify-content-between align-items-center'>
            <div>
              <p className='mb-0'>{selectedFile.name}</p>
              <small className='text-muted'>{(selectedFile.size / 1024 / 1024).toFixed(2)} MB</small>
            </div>
            <button
              className='border-0 rounded-circle bg-transparent'
              onClick={handleRemoveFile}
              disabled={isUploading}
            >
              <RiCloseLine size={24} />
            </button>
          </div>
        </div>
      )}

      <Button type='submit' className='border-0 common-btn w-100 mt-2 py-2' disabled={!selectedFile || isUploading}>
        {isUploading ? (
          <div className='d-flex align-items-center justify-content-center gap-2'>
            <Spinner animation='border' size='sm' />
            <span>Uploading</span>
          </div>
        ) : (
          'Upload'
        )}
      </Button>
    </Form>
  )
}

export default DementiaForm
